import { BioDetail } from "@components/BioDetail"

export default BioDetail
